/**
 * Nom d'un dossier : largeur de `batch_import.data_set_name` et limite du contrat de la gateway,
 * qui répond 400 au-delà. L'import par email et l'API publique créent déjà des noms de cette taille.
 */
export const MAX_DOSSIER_NAME_LENGTH = 255

/** Nom d'un fichier : largeur de `batch_import_file.name` (V428 de nabu-backend) et limite du contrat. */
export const MAX_FILE_NAME_LENGTH = 255
